import { useMemo } from "react"
import { useQuery } from "urql"

import "@/screens/Companies/edit/graphql/comments.query"

import type { Comment, CommentListQueryQuery, CommentListQueryQueryVariables } from "@/graphql/codegen/graphql"
import { CommentListQueryDocument, CommentParentTableType } from "@/graphql/codegen/graphql"

export interface UseGetTransferCommentReturn {
  comment: Comment | undefined
  isFetching: boolean
  refetch: () => void
}

export const useGetTransferComment = (transferId?: string): UseGetTransferCommentReturn => {
  const [{ data, fetching }, refetch] = useQuery<CommentListQueryQuery, CommentListQueryQueryVariables>({
    query: CommentListQueryDocument,
    variables: { referenceId: transferId ?? "", parentTableType: CommentParentTableType.Transfer },
    pause: !transferId,
  })

  const output = data?.comment?.list

  const comment = useMemo(
    () => (output?.__typename === "CommentListSuccess" ? (output.comments[0] as Comment | undefined) : undefined),
    [output]
  )

  return { comment, isFetching: fetching, refetch: () => refetch({ requestPolicy: "network-only" }) }
}
